import { render, staticRenderFns } from "./ViTeacherHome.vue?vue&type=template&id=1b8b2e66"
import script from "./ViTeacherHome.vue?vue&type=script&lang=js"
export * from "./ViTeacherHome.vue?vue&type=script&lang=js"
import style0 from "./ViTeacherHome.vue?vue&type=style&index=0&id=1b8b2e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports